// não pode estar logado para acessar

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../global-components/src';

interface UnauthenticatedRouteProps {
    children: React.ReactNode; // Recebe os filhos que serão protegidos
}

const UnauthenticatedRoute : React.FC<UnauthenticatedRouteProps> = ({ children }) => {
    const { isAuthenticated } = useAuth();
    if (isAuthenticated) {
        return <Navigate to="/livros" replace />; // Redireciona para login se não autenticado
    }
    return <>{children}</>; // Retorna os filhos se autenticado
};

export default UnauthenticatedRoute ;
